import { toast } from "react-toastify";

export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    Processing = 102,
    Ok = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultiStatus = 207,
    AlreadyReported = 208,
    ImUsed = 226,
    MultipleChoices = 300,
    MovedPermanently = 301,
    Found = 302,
    SeeOther = 303,
    NotModified = 304,
    UseProxy = 305,
    SwitchProxy = 306,
    TemporaryRedirect = 307,
    PermanentRedirect = 308,
    BadRequest = 400,
    Unauthorized = 401,
    PaymentRequired = 402,
    Forbidden = 403,
    NotFound = 404,
    MethodNotAllowed = 405,
    NotAcceptable = 406,
    ProxyAuthenticationRequired = 407,
    RequestTimeout = 408,
    Conflict = 409,
    Gone = 410,
    LengthRequired = 411,
    PreconditionFailed = 412,
    PayloadTooLarge = 413,
    UriTooLong = 414,
    UnsupportedMediaType = 415,
    RangeNotSatisfiable = 416,
    ExpectationFailed = 417,
    IAmATeapot = 418,
    MisdirectedRequest = 421,
    UnprocessableEntity = 422,
    Locked = 423,
    FailedDependency = 424,
    UpgradeRequired = 426,
    PreconditionRequired = 428,
    TooManyRequests = 429,
    RequestHeaderFieldsTooLarge = 431,
    UnavailableForLegalReasons = 451,
    InternalServerError = 500,
    NotImplemented = 501,
    BadGateway = 502,
    ServiceUnavailable = 503,
    GatewayTimeout = 504,
    HttpVersionNotSupported = 505,
    VariantAlsoNegotiates = 506,
    InsufficientStorage = 507,
    LoopDetected = 508,
    NotExtended = 510,
    NetworkAuthenticationRequired = 511
}

export class HttpException extends Error {
    statusCode: HttpStatusCode;
    errorList: string[];

    constructor(statusCode: HttpStatusCode, errorList: string[]) {
        super("Http exception");
        this.statusCode = statusCode;
        this.errorList = errorList;
    }
}

export class UnauthorizedException extends Error {
    constructor() {
        super("Unauthorized exception");
    }
}

export const fetchJSON = async (url: string, method: string, data?: any, customHeaders?: { [key: string]: string }) => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
        window.location.replace("/");
        return;
    }
    const headers = new Headers({
        Authorization: accessToken,
        "Content-Type": "application/json",
        ...customHeaders
    });

    return fetch(url, {
        method: method || "GET",
        body: data ? JSON.stringify(data) : undefined,
        headers: headers
    })
        .then(async (response) => {
            if (!response.ok) {
                let statusText = "There is a problem. Please try again in 5 minutes";
                switch (response.status) {
                    case HttpStatusCode.Unauthorized:
                        statusText = "Access forbidden";
                        //  await AuthService.refreshAccessToken(refreshToken);
                        //  return fetchWithRetryOn401(url, method, false, data);
                        break;
                    case HttpStatusCode.Forbidden:
                        statusText = "Access forbidden";
                        break;
                    case HttpStatusCode.NotFound:
                        statusText = "Endpoint not found";
                        break;
                }

                const resJson = await response.json().catch(() => null);
                if (resJson?.message && resJson?.message !== "") {
                    statusText = resJson?.message;
                }
                toast.error(statusText);
                return;
            }
            return response.json();
        })
        .catch((error: TypeError) => {
            console.error("fetch error: ", error)
            toast.error(error.message);
            return;
            // throw error;
        });
};
